import MDButton from 'components/MDButton'
import React, { useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import {
  TextareaAutosize,
} from '@mui/material'
import { useAppServices } from 'hook/services'
import MDInput from 'components/MDInput'
import Multiselect from './components/Multiselect'

const EditModal = ({ data, handleRefresh }) => {
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()

  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)

    const handleSubmit = async (e) => {
      e.preventDefault()

      // Prepare the award_claimed object with the updated status keys
      const updatedAwardClaimed = { ...data?.award_config?.award_claimed }

      // Update award status based on selected status in the form
      if (data?.award_config?.award_claimed?.silver) {
        updatedAwardClaimed.silver_status = e.target.silver_status.value
      }

      if (data?.award_config?.award_claimed?.gold) {
        updatedAwardClaimed.gold_status = e.target.gold_status.value
      }

      if (data?.award_config?.award_claimed?.platinum) {
        updatedAwardClaimed.platinum_status = e.target.platinum_status.value
      }

      // Prepare the payload to update the database
      const payload = {
        company_id: data?.CompanyID,
        award_config: {
          ...data?.award_config,
          award_claimed: updatedAwardClaimed, // Updated award_claimed with status changes
        }
      }

      console.log('Updated Payload:', payload)

      const { response } = await AppService.agency.update_ghl_company({
        payload,
        toaster: true
      })

      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '100%',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }

    const statusOptions = [
      {
        label: 'Being Packed',
        value: 'being-packed',
      },
      {
        label: 'Ready for shipping',
        value: 'Ready-for-shipping',
      },
      {
        label: 'Shipped',
        value: 'shipped',
      }
    ]

    return (
      <MDModal open={open} onClose={onClose} width={540}>
        <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
          <MDTypography variant="h5" mb={2}>
            Update Award Request
          </MDTypography>

          <MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Company Name
            </MDTypography>
            <MDInput placeholder="Name" InputProps={{ readOnly: true }} name="name" fullWidth defaultValue={data?.award_config?.company_name || data?.Name} />
          </MDBox>
          <MDBox>
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Address
            </MDTypography>
            <TextareaAutosize
              readOnly={true}
              type="text"
              name="desc"
              minRows={3}
              style={{ width: '100%', padding: '2px' }}
              defaultValue={data?.award_config?.award_address}
            />
          </MDBox>
          {data?.award_config?.award_claimed?.silver && (
            <MDBox display="flex" justifyContent="space-between" gap={2}>
              <MDBox flex={1}>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  Award
                </MDTypography>
                <MDInput
                  placeholder="1000 Award"
                  name="silver"
                  fullWidth
                  InputProps={{ readOnly: true }}
                  defaultValue={'1000 Award'}
                />
              </MDBox>

              <MDBox flex={1}>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  Status
                </MDTypography>
                <Multiselect data={statusOptions} edit_data={data?.award_config?.award_claimed?.silver_status ? JSON.parse(data?.award_config?.award_claimed?.silver_status) : ''} isMulti={false} name="silver_status" />
              </MDBox>
            </MDBox>
          )}
          {data?.award_config?.award_claimed?.gold && (
            <MDBox display="flex" justifyContent="space-between" gap={2}>
              <MDBox flex={1}>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  Award
                </MDTypography>
                <MDInput
                  placeholder="10,000 Award"
                  name="silver"
                  fullWidth
                  InputProps={{ readOnly: true }}
                  defaultValue={'10,000 Award'}
                />
              </MDBox>

              <MDBox flex={1}>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  Status
                </MDTypography>
                <Multiselect data={statusOptions} edit_data={data?.award_config?.award_claimed?.gold_status ? JSON.parse(data?.award_config?.award_claimed?.gold_status) : ''} isMulti={false} name="gold_status" />
              </MDBox>
            </MDBox>
          )}
          {data?.award_config?.award_claimed?.platinum && (
            <MDBox display="flex" justifyContent="space-between" gap={2}>
              <MDBox flex={1}>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  Award
                </MDTypography>
                <MDInput
                  placeholder="100,000 Award"
                  name="silver"
                  fullWidth
                  InputProps={{ readOnly: true }}
                  defaultValue={'100,000 Award'}
                />
              </MDBox>

              <MDBox flex={1}>
                <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                  Status
                </MDTypography>
                <Multiselect data={statusOptions} edit_data={data?.award_config?.award_claimed?.platinum_status ? JSON.parse(data?.award_config?.award_claimed?.platinum_status) : ''} isMulti={false} name="platinum_status" />
              </MDBox>
            </MDBox>
          )}
          <MDBox display="flex" justifyContent="flex-end">
            <MDButton
              variant="gradient"
              color="primary"
              type="button"
              sx={{ mt: 4, mb: 1 }}
              onClick={closeAddProduct}
            >
              close
            </MDButton>
            <MDButton
              variant="gradient"
              color="info"
              type="submit"
              sx={{ mt: 4, mb: 1, ml: 1 }}
              loading={processing}
              disabled={processing}
            >
              Update
            </MDButton>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton color="info" variant="contained" onClick={handlemodal}>
        Edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} data={data} />
    </>
  )
}

export default EditModal
